module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/PatriotGames.f0fe09b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/PatriotGames.jpg
// module id = 4b58
// module chunks = 0